import { render, staticRenderFns } from "./StaffChargeDaily.vue?vue&type=template&id=4835be42"
import script from "./StaffChargeDaily.vue?vue&type=script&lang=js"
export * from "./StaffChargeDaily.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports